// Shared wine catalog. `tint` is the card/thumbnail background and
// `fill` is the glass colour on the bottle illustration.
export const inventory = [
  { name: "Moon White", kind: "White", cost: "100", tint: "#EDF2F1", fill: "#DCE6E3" },
  { name: "Starse Rosé", kind: "Rosé", cost: "150", tint: "#FAEDEE", fill: "#F0CFD3" },
  { name: "Sunset Red", kind: "Red", cost: "200", tint: "#ECEEED", fill: "#343B37" },
  { name: "Chardonnay", kind: "White", cost: "250", tint: "#F5F2E8", fill: "#E6DFC6" },
];

const FALLBACK = { tint: "#EDF2F1", fill: "#DCE6E3", kind: "" };

// Cart items persisted before the refresh only carry name/cost/image.
export function resolveProduct(item) {
  const match = inventory.find((p) => p.name === item.name);
  return { ...FALLBACK, ...(match || {}), ...item };
}

export const money = (n) => `$${Number(n || 0).toFixed(2)}`;
